import axios from 'axios';
import baseURL from '../../Config';

export async function tcnApi(path, { method = 'GET', data, query } = {}) {
    const stored = JSON.parse(localStorage.getItem('adminUser') || localStorage.getItem('userDetails') || '{}');
    const params = new URLSearchParams(Object.entries(query || {}).filter(([, value]) => value !== '' && value !== undefined && value !== null));
    try {
        const response = await axios({ url: `${baseURL}tcn/${path}${params.toString() ? `?${params}` : ''}`, method, data,
            headers: { Authorization: `Bearer ${stored?.data?.token || stored?.data?.accessToken}` } });
        return response.data.data;
    } catch (error) {
        throw Object.assign(new Error(error.response?.data?.message || 'No se pudo conectar con TCN. Intenta de nuevo.'), {
            status: error.response?.status, details: error.response?.data?.data
        });
    }
}

export const money = (cents) => new Intl.NumberFormat('es-PA', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
export const dateTime = (value) => value ? new Intl.DateTimeFormat('es-PA', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'America/Panama' }).format(new Date(value)) : '—';
export const payLabel = (value) => ({ 1: 'Efectivo', 2: 'Tarjeta' }[value] || `Otro (código ${value})`);
export function panamaDay(date = new Date()) {
    const parts = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'America/Panama' }).formatToParts(date);
    const get = (type) => parts.find((part) => part.type === type).value;
    return `${get('year')}-${get('month')}-${get('day')}`;
}
